module.exports = __webpack_public_path__ + "img/Celta-de-Vigo.6621a6f5.png";